import React from "react";
import { Button, Col } from "react-bootstrap";
import popular1 from "../../assets/popular1.png";

const CarousalCard = ({ eachitem }) => {
  return (
    <Col className="m-2">
      <div className="card p-3">
        <img loading="lazy" className="d-block w-100" src={popular1} alt="First slide" />
        <div className="tag">
          <p className="loc-detail-1 mt-3">{eachitem.business_category}</p>
          <div className="tag-main">
            <p className="ribben">VOUCHER</p>
          </div>
        </div>
        <p className="loc-detail-2">Upto {eachitem.voucher_title} </p>
        <p className="loc-detail-3">by {eachitem.business_name}</p>
        <div className="d-flex">
          <p className="loc-price-1">${eachitem.voucher_actual_price}</p>
          <p className="loc-price-2">${eachitem.voucher_offer_price}</p>
          <p className="loc-price-offer">70% OFF</p>
        </div>
        <Button className="mt-3 text-center green-btn">Buy Now</Button>
      </div>
    </Col>
  );
};

export default CarousalCard;
